import { IHttpService, IQService } from "angular";
import { InstanceDb } from "../instance-db.service";

export class NavigationService {
    constructor(private $http: IHttpService, private $q: IQService,
        private instanceDb: InstanceDb,
        private apexApiUrl: string) {
        "ngInject"

        this.$http = $http
        this.$q = $q
        this.apexApiUrl = apexApiUrl
    }

    /**
     * Return the list of navigation modules visible to the current user.
     * @returns {Promise<any[]>} The list of navigation items.
     */
    retrieveNavigationModules() {
        const cached = this.instanceDb.sessionStorage.getItem("apexNavigation");
        if (cached) {
            return this.$q.when(JSON.parse(cached))
        }

        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "Home/navigation-modules",
            headers: { Accept: "application/json" }
        }).then(response => {
            this.instanceDb.sessionStorage.setItem("apexNavigation", JSON.stringify(response.data))
            return response.data
        })
    }
}
